// extracted by css-extract-rspack-plugin
export default {"root":"dIr6tii_kjs0xmf2","explore":"wss7B53UyE0ccb7v"};